import * as React from 'react'
import classNames from 'classnames'

export type Message = {
  description: string
}

export default function Messages({
  messages,
  needs2Rows,
}: {
  messages: Message[]
  needs2Rows: boolean
}) {
  const amount = messages.length
  const hasMoreThan1Message = amount > 1
  const [index, setIndex] = React.useState(0)
  const activeMessage = messages[index]

  const rowWrapperClasses = classNames(
    'flex flex-col h-full bg-primary-yellow text-primary-grey',
    {
      'max-h-[50%]': needs2Rows,
      'max-h-[25%]': !needs2Rows,
    },
  )
  const contentWrapperClasses = classNames(
    'flex flex-grow gap-2 px-5 font-flanders font-bold text-[40px]',
    {
      'pt-3': amount === 1,
      'pt-1.5': amount > 1,
      'leading-[1.125]': activeMessage.description.length >= 175, // limited line-height
      'leading-[1.25]': activeMessage.description.length < 175, // sligthly more line-height
      '!leading-[1.375]': needs2Rows, // a lot of line-height for a lot of space
    },
  )

  React.useEffect(() => {
    if (messages.length === 1) {
      // no need to interval when only 1 message is present
      return () => {} // eslint-disable-line @typescript-eslint/no-empty-function
    }
    const timeInterval = window.setInterval(() => {
      setIndex((index) => (index + 1 === messages.length ? 0 : index + 1))
    }, 10_000)
    return function cleanup() {
      return window.clearInterval(timeInterval)
    }
  }, [])

  return (
    <div className={rowWrapperClasses} key={index}>
      {hasMoreThan1Message && (
        <div data-testid="loader" className="h-3 bg-secondary-500">
          <div
            data-testid="loader-inner"
            className="animate-width h-full w-60 bg-secondary-700 rounded-r-md"
          />
        </div>
      )}
      <div className={contentWrapperClasses}>
        <div data-testid="content" className="flex flex-col flex-1">
          {activeMessage.description}
        </div>
        {hasMoreThan1Message && (
          <div className="flex flex-row w-[72px] min-w-[72px] max-w-[72px] text-secondary-700 justify-end">
            {`${index + 1}/${amount}`}
          </div>
        )}
      </div>
    </div>
  )
}
